export const AvatarConfiguration = {
    cogSvcRegion: "westeurope",
    cogSvcSubKey: "2dc04a1b1ca949f3b687578c7c2c08e4",
    voiceName: "en-US-EmmaMultilingualNeural",
    avatarCharacter: "lori",
    avatarStyle: "graceful",
    avatarBackgroundColor: "#00FF00FF",
    iceUrl:"stun:relay.communication.microsoft.com:3478",
    iceUsername:"YOUR_ICE_USERNAME",
    iceCredential:"YOUR_ICE_CREDENTIAL",
    pageTitle: "Avatar test",
    videoCodec : "vp9",
    VideoFormat: "webm",

}
